import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import { EChartsOption } from "echarts";
import { ResultItem } from "./SideRainCurrentChart";

interface sensorItem {
  id: string;
  fullScreen: boolean;
  showDialog: boolean;
  chartWidth: number;
  chartHeight: number;
  location:string;
  currentDay:string;
  differant:string;
}

const RainLastDayChart: React.FC<sensorItem> = ({
  id,

  fullScreen,
  showDialog,
  chartWidth,
  chartHeight,
  location,
  currentDay,
  differant
}) => {
const chartRef = useRef<HTMLDivElement>(null);
  const [chartInstance, setChartInstance] = useState<echarts.ECharts>();
  const [secondDataSetReceived, setSecondDataSetReceived] =
    useState<boolean>(false);
  const [legendData, setLegendData] = useState<string[]>(['Last-24h']);
  const [initialData, setInitialData] = useState<any[]>([]);
  const [currentLevel, setCurrentLevel] = useState<any[]>([]);
  const [diffLevel, setDiffLevel] = useState<any[]>([]);
  const [cLevelName, setCLevelName] = useState<string>("");
  const [diffName, setDiffName] = useState<string>("");
  const [dayName, setDayName] = useState<string>("");
  const [initialLoad, setInitialLoad] = useState<boolean>(true);

  const REACT_APP_RAIN_THREE_URL = process.env.REACT_APP_RAIN_THREE_URL;
  const RAIN_CURRENT_THREE_URL = process.env.REACT_APP_RAIN_CURRENT_THREE_URL;
  const RAIN_DIFF_THREE_URL = process.env.REACT_APP_RAIN_DIFF_THREE_URL;
  const RAIN_24H_URL = process.env.REACT_APP_RAIN_24H_URL;

    useEffect(() => {
      const fetchDataAndInitializeChart = async () => {
        try {
          const response = await fetch(
            `${REACT_APP_RAIN_THREE_URL}${id}`
          );
          const responseData = await response.json();
    
          if (responseData && Array.isArray(responseData.results)) {
            // Process the results array
            const data = responseData.results
              .map((item: ResultItem) => {
                const cleanTimestamp = item.timestamp.replace(/\+\d{2}\.\d{3}Z$/, "+01:00");
                const parsedDate = new Date(cleanTimestamp);
    
                if (isNaN(parsedDate.getTime())) {
                  console.error("Invalid timestamp:", item.timestamp);
                  return null;
                }
                return [parsedDate.toISOString(), item.value];
              })
              .filter((entry:any): entry is [string, number] => entry !== null);
            if (data.length > 0) {
              setInitialData(data);
            setDayName("last");
            } else {
              console.error("No valid data points found:", responseData.results);
            }
          } else {
            console.error("Unexpected response data format:", responseData);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
    
      fetchDataAndInitializeChart();
    }, [ id]);
  
  
    useEffect(() => {}, [dayName]);

      useEffect(() => {
        const fetchDataAndInitializeChart = async () => {
          try {
            const response = await fetch(
              `${RAIN_CURRENT_THREE_URL}${id}`
            );
            const responseData = await response.json();
      
            if (responseData && Array.isArray(responseData.results)) {
              // Process the results array
              const data = responseData.results
                .map((item: ResultItem) => {
                  const cleanTimestamp = item.timestamp.replace(/\+\d{2}\.\d{3}Z$/, "+01:00");
                  const parsedDate = new Date(cleanTimestamp);
      
                  if (isNaN(parsedDate.getTime())) {
                    console.error("Invalid timestamp:", item.timestamp);
                    return null;
                  }
                  return [parsedDate.toISOString(), item.value];
                })
                .filter((entry:any): entry is [string, number] => entry !== null);
              if (data.length > 0) {
                setCurrentLevel(data);
                setCLevelName("Current Rainfall");
              } else {
                console.error("No valid data points found:", responseData.results);
              }
            } else {
              console.error("Unexpected response data format:", responseData);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
      
        fetchDataAndInitializeChart();
      }, [currentDay, id]);

                    useEffect(() => {
                         const fetchDataAndInitializeChart = async () => {
                           try {
                             const response = await fetch(
                               `${RAIN_DIFF_THREE_URL}${id}`
                             );
                             const responseData = await response.json();
                       
                             if (responseData && Array.isArray(responseData.results)) {
                               // Process the results array
                               const data = responseData.results
                                 .map((item: ResultItem) => {
                                   const cleanTimestamp = item.timestamp.replace(/\+\d{2}\.\d{3}Z$/, "+01:00");
                                   const parsedDate = new Date(cleanTimestamp);
                       
                                   if (isNaN(parsedDate.getTime())) {
                                     console.error("Invalid timestamp:", item.timestamp);
                                     return null;
                                   }
                                   return [parsedDate.toISOString(), item.value];
                                 })
                                 .filter((entry:any): entry is [string, number] => entry !== null);
                               if (data.length > 0) {
                                setDiffLevel(data);
                                setDiffName("Difference");
                               } else {
                                 console.error("No valid data points found:", responseData.results);
                               }
                             } else {
                               console.error("Unexpected response data format:", responseData);
                             }
                           } catch (error) {
                             console.error("Error fetching data:", error);
                           }
                         };
                       
                         fetchDataAndInitializeChart();
                       }, [differant, id]);
    

  useEffect(() => {
    if (
      chartRef.current &&
      chartRef.current.clientWidth &&
      chartRef.current.clientHeight
    ) {
      const chart = echarts.init(chartRef.current);

      const chartOption: EChartsOption = {
        color: ["#80FFA5", "#00DDFF", "#37A2FF", "#FF0087", "#FFBF00"],
        title: {
          left: "center",
          text: "Last 24 hours",
          textStyle: {fontSize:"0.8rem",
            color: "#03FE03",
          },
       

        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
     
        legend: {
          data: ['Last-24h', cLevelName,diffName],
          textStyle: {
            color: "#FFFFFF",
          },
          right: "10%",
          top: "10%",
          backgroundColor: 'rgba(0,0,0,0.5)',
          padding: [5, 10],
          borderRadius: 4,
          itemGap: 10,
          itemWidth: 20,
          itemHeight: 10
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "14%",
          bottom: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "time",
          name: "Time",
          axisLabel: {
            color: "#FFFFFF",
          },
          // boundaryGap: [0, "100%"],
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 2,
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Rainfall",
          nameTextStyle: {
            color: "#FFFFFF",
          },
          axisLabel: {
            formatter: "{value} mm",
            color: "#FFFFFF",
          },
          boundaryGap: [0, "100%"],
          axisLine: {
            lineStyle: {
              color: "#070807",
              width: 2,
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(85, 84, 95, 0.6)",
              width: 1,
            },
          },
          // ...splitLineStyle,
        },

        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        visualMap: {
          type: "piecewise",
          show: false,
          dimension: 1,
          pieces: [
            {
              gt: 0,
              lt: 50000,
              color: "#1e8ce6",
            },

          ],
        },
        series: [
          {
            name: "Last-24h",
            type: "line",
            stack: "Total",
            smooth: true,
            symbol: "arrow",
            lineStyle: {
              width: 0,
            },
            itemStyle: {
              color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: initialData,
 
          },
        ],
      };
      chart.setOption(chartOption);
      setChartInstance(chart);
    }

    return () => {
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, [initialData]);

  const generateNewData = async () => {
    try {
      const response = await fetch(
        `${RAIN_24H_URL}` +
          id
      );
      const responseData = await response.json();

      if (responseData && Array.isArray(responseData.results)) {
        const newData = responseData.results.map((item: any) => [
          item.time,
          item.level,
        ]);
        setInitialData((prevData) => [...prevData, ...newData]);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (showDialog) {
      const interval = setInterval(() => {
        generateNewData();
      }, 15 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [showDialog]);

  useEffect(() => {
    const updateChartSeries = () => {
      if (chartInstance && currentLevel && currentLevel.length > 0) {
        const option = chartInstance.getOption() as echarts.EChartsOption;

        if (!Array.isArray(option.series)) {
          option.series = [];
        }

        option.title={
          left: "left",
          text: "Current Rainfall",
          textStyle: {fontSize:"0.8rem",
            color: "#FFFFFF",
            
          },
        };
        

        option.series = option.series.concat({
          name: "Current Rainfall",
          type: "line",
          smooth: true,
          symbol: "arrow",

          data: currentLevel,
          lineStyle: {
            width: 0,
          },
          itemStyle: {
            color:  "#21f505",
          },
          areaStyle: {
            opacity: 0.8,
            color: "#21f505",
          },
          emphasis: {
            focus: "series",
          },
        });

        setLegendData((prevLegendData) => {
          const newLegendData = [...prevLegendData, 'Current Rainfall'];
          option.legend = {
            ...option.legend,
            data: newLegendData,
            textStyle: {
              color: "#FFFFFF",
            },
            right: "10%",
            top: "10%",
          };
          return newLegendData;
        });

        chartInstance.setOption(option);
      }
    };
    // updateChartSeries();
    const timeoutId = setTimeout(updateChartSeries, 500);

    return () => clearTimeout(timeoutId);
  }, [currentLevel, chartInstance]);

  useEffect(() => {
    const updateChartSeries = () => {
      if (chartInstance && diffLevel && diffLevel.length > 0) {
        const option = chartInstance.getOption() as echarts.EChartsOption;

        if (!Array.isArray(option.series)) {
          option.series = [];
        }

        option.title={
          left: "center",
          text: "Last 24 hours",
          textStyle: {fontSize:"0.8rem",
            color: "#03FE03",
            
          },
        };

        option.series = option.series.concat({
          name: 'Difference',
          type: "line",
          smooth: true,
          symbol: "arrow",

          data: diffLevel,
          lineStyle: {
            width: 0,
          },
          itemStyle: {
            color: "#ba2709",
          },
          areaStyle: {
            opacity: 0.8,
            color: "#ba2709",
          },
          emphasis: {
            focus: "series",
          },
        });

        

        setLegendData((prevLegendData) => {
          const newLegendData = [...prevLegendData, 'Difference'];
          option.legend = {
            ...option.legend,
            data: newLegendData,
            textStyle: {
              color: "#FFFFFF",
            },
            right: "10%",
            top: "10%",
            selected: {
              'Legend A': true,
              'Current Rainfall': false,
              'Difference': false
            }
          };
          return newLegendData;
        });

        chartInstance.setOption(option);
      }
    };
    // updateChartSeries();
    const timeoutId = setTimeout(updateChartSeries, 1000);

    // Cleanup to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, [diffLevel, chartInstance]);


  useEffect(() => {
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [chartInstance]);

  useEffect(() => {

    if(chartWidth !== 0){
      setInitialLoad(false);
    }
  }, [chartWidth,initialLoad]);

  useEffect(() => {
    if (chartInstance) {
      chartInstance.resize();
    }
  }, [chartWidth,chartHeight]); 

  useEffect(() => {
    if (chartInstance) {
      setTimeout(() => {
        chartInstance.resize();
      }, 100);
    }
  }, [fullScreen]);

  useEffect(() => {
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [chartInstance]);

  return (
    <div
      id="main"
      style={{
        width: initialLoad ? "25vw" : `${chartWidth}px`,
        height: initialLoad?"100%" :`${chartHeight}px`}} 
      ref={chartRef}
    ></div>
  );
};

export default RainLastDayChart;
